import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import request from '../../lib/request';
import utils from '../../lib/utils';
import { Flex } from '../../lib/components/LessonPath/static/style';
import Back from '../../lib/components/LessonPath/back';
import { reqAPI } from "../../server/reqAPI";
import { abnormalReporting } from '../../server/commonFun';

export default class Subject extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            subjectData: null,
        }
    }

    componentDidMount() {
        this.handleGetSubjectData();
        window.addEventListener('mousewheel', this.onScrollHandler);
        window.addEventListener('DOMMouseScroll', this.onScrollHandler);
    }

    componentWillUnmount() {
        window.removeEventListener('mousewheel', this.onScrollHandler);
        window.removeEventListener('DOMMouseScroll', this.onScrollHandler);
    }

    // 监听滚动事件（鼠标上下滚动时，列表左右滚动）
    onScrollHandler = e => {
        var lessonListElement = this.refs.lessonBox;

        if (lessonListElement) {
            if (/(macintosh).*(mac os x)/i.test(navigator.userAgent.toLocaleLowerCase())) {
                lessonListElement.scrollLeft += e.wheelDeltaY / 2;
            } else {
                lessonListElement.scrollLeft += -e.wheelDeltaY / 2;
            }
        }
    };

    // 点击返回处理事件
    clickBackHandler() {
        if (document.referrer) {
            window.history.back();
        } else {
            window.location.href = '#/';
        }
    }

    // 获取数据
    handleGetSubjectData() {
        utils.showCommonLoading();
        request(reqAPI.subject_course, this.context.user, { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                utils.hideCommonLoading();
                if (res.code && res.code === 200) {
                    this.setState({
                        subjectData: res.data,
                    });
                } else {
                    abnormalReporting({
                        putaoid: this.context.user.putaoid,
                        url: reqAPI.subject_course,
                        type: 'data',
                        res
                    });
                }
            })
            .catch(err => {
                utils.hideCommonLoading();
                abnormalReporting({
                    putaoid: this.context.user.putaoid,
                    url: reqAPI.subject_course,
                    type: 'request',
                    err
                });
            });
    }

    // 点击主题学习卡片
    handleClickCard(item) {
        if (item && item.pageUrl) {
            window.location.href = item.pageUrl;
        } else {
            utils.showTips('内容有误！请刷新重试');
        }
    }

    render() {
        const { subjectData } = this.state;

        return (
            <SubjectStyled>
                <Back onClick={this.clickBackHandler.bind(this)} />
                <PageTitle>主题学习</PageTitle>
                <ListBox ref='lessonBox'>
                    <List>
                        <PlaceHolderCard />
                        {subjectData && Array.isArray(subjectData) && subjectData.map((item, index) =>
                            <Item key={index} onClick={() => this.handleClickCard(item)}>
                                <Picture src={item.imageUrl || ''} alt='' />
                                {item.tagImgUrl && <TagPicture src={item.tagImgUrl || ''} />}
                                {item.engTitle && <Title>{item.engTitle}</Title>}
                                {item.chiTitle && <Title>{item.chiTitle}</Title>}
                                <CourseNum>
                                    {/* {item.learnLessonNum ?
                                        `已学至第${item.learnLessonNum}节`
                                        : `共${item.allLessonNum || 0}节`} */}
                                    {item.learningProgress}
                                </CourseNum>
                            </Item>
                        )}
                        <PlaceHolderCard />
                    </List>
                </ListBox>
            </SubjectStyled>
        );
    }
}

// 定义子组件需要使用的属性
Subject.contextTypes = {
    user: PropTypes.object,
    userInfo: PropTypes.object,
    getUser: PropTypes.func,
};

const SubjectStyled = styled.div`
    position: relative;
    height: 100%;
    min-width: 100%;
    background: #fff url(${require('../../static/img/subject/bg_ztk@3x.png')}) no-repeat center;
    background-size: 100% 100%;

    &::after, &::before {
        position: absolute;
        content: '';
        display: block;
        top: 0;
    }

    &::before {
        width: 6.44rem;
        height: 3.67rem;
        left: 0;
        background: url(${require('../../static/img/subject/left_tree@3x.png')}) no-repeat right top;
        background-size: contain;
    }

    &::after {
        width: 6.54rem;
        height: 6.13rem;
        right: 0;
        background: url(${require('../../static/img/subject/right_tree@3x.png')}) no-repeat left top;
        background-size: contain;
    }
`;

const PageTitle = styled.div`
    position: fixed;
    top: 0.58rem;
    left: 0;
    width: 100%;
    font-size: 0.38rem;
    color: #268248;
    text-align: center;
    font-weight: 800;
`;

const ListBox = styled(Flex)`
    position: relative;
    width: 100%;
    height: 100%;
    align-items: center;
    overflow-x: scroll;
    overflow-y: hidden;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    z-index: 1;

    &::-webkit-scrollbar {
        width: 0 !important;
    }
`;

const List = styled(Flex)`
    min-width: 100%;
`;

const Item = styled.div`
    position: relative;
    width: 5.76rem;
    height: 4.67rem;
    background: #fff;
    border-radius: 0.32rem;
    margin: 0 0.24rem;
    padding: 0.16rem;
    box-shadow: 0px 0.03rem 0.22rem 0px rgba(72,107,37,0.2);
    color: #323237;
    font-size: 0.32rem;
    cursor: pointer;
`;

const PlaceHolderCard = styled(Item)`
    /* 直接写宽度，最右侧的卡片会没有宽度 */
    flex: none;
    width: 1.12rem;
    background: transparent;
    box-shadow: none;
    margin: 0;
    height: 0;
`;

const Picture = styled.img`
    display: block;
    width: 5.44rem;
    height: 3.04rem;
    border-radius: 0.16rem;
    margin-bottom: 0.26rem;
`;

const TagPicture = styled.div`
    position: absolute;
    top: -0.05rem;
    left: 0.32rem;
    width: 0.96rem;
    height: 0.56rem;
    background: url(${props => props.src || ''}) no-repeat center;
    background-size: 100% 100%;
`;

const Title = styled.div`
    line-height: 0.45rem;
`;

const CourseNum = styled.div`
    position: absolute;
    top: 2.59rem;
    right: 0.32rem;
    padding: 0.05rem 0.19rem;
    border-radius: 0.22rem;
    background: rgba(0,0,0,0.3);
    color: #fff;
    font-size: 0.23rem;
    line-height: 0.35rem;
    text-align: center;
`;


// WEBPACK FOOTER //
// ./src/route/version-3/Subject.js